(function () {
  'use strict';

  angular.module('app').service('ConfirmXmlModalService', ConfirmXmlModalService);

  ConfirmXmlModalService.$inject = ['ModalService', 'ConfirmXmlService'];

  function ConfirmXmlModalService(ModalService, ConfirmXmlService) {
    var preventModalClose = {
      backdrop: 'static',
      keyboard: false,
    };

    var service = {
      openConfirmXmlDetail: openConfirmXmlDetail,
    };

    return service;

    // Modal bill send email
    function openConfirmXmlDetail(id) {
      ModalService.showModal({
        templateUrl: './app/ajs/confirm-xmls/modals/confirm-xml-detail-modal.html',
        controller: ConfirmXmlDetailCtrl,
        controllerAs: 'vm',
        inputs: {
          id: id,
        },
      }).then(function (modal) {
        modal.element.modal(preventModalClose);
      });
    }

    function ConfirmXmlDetailCtrl(id) {
      var vm = this;

      vm.id = id;

      //Initializer
      getConfirmXml(vm.id);

      function getConfirmXml(id) {
        vm.sendingForm = true;

        ConfirmXmlService.getConfirmXml(id).then(function (data) {
          vm.item = data;

          vm.sendingForm = false;
        });
      }
    }
  }
})();
